import type React from 'react';

const Placeholder = (): React.JSX.Element => {
	return (
		<div
			className="pointer-events-none h-full min-h-48 w-full rounded-lg border border-dashed border-border bg-muted/20"
			aria-hidden
		/>
	);
};

export default Placeholder;
